import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { ITherapySuppliers } from 'Interfaces/therapySuppliers';
import * as yup from 'yup';

const dictionary = Dictionary[DICTIONARY.Suppliers];

export const SuppliersSchema = yup.object().shape({
  supName: yup.string().nullable().default(null),
  specialty: yup.number().nullable().required(dictionary.requiredError),
  expertise: yup.array().of(yup.number().nullable().default(null)),
  area: yup.number().nullable().default(null),
  region: yup.number().nullable().default(null),
  city: yup.array().of(yup.number().nullable().default(null)),
  accessible: yup.boolean().nullable().default(null),
  lng: yup.array().of(yup.number().nullable().default(null)),
  gender: yup.number().nullable().default(null),
  treatMethod: yup.array().of(yup.number().required()),
  homeVisit: yup.boolean().nullable().default(null),
  instituteId: yup.boolean().nullable().default(null),
}) as yup.SchemaOf<ITherapySuppliers>;
